import { ILocality2 } from '../../commomTypes';

// Action Types
export enum Types {
  LOAD_CUSTOMERS = 'customers/LOAD_CUSTOMERS',
  LOAD_CUSTOMERS_SUCCESS = 'customers/LOAD_CUSTOMERS_SUCCESS',
  LOAD_CUSTOMERS_FAILURE = 'customers/LOAD_CUSTOMERS_FAILURE',

  LOAD_CUSTOMER_BY_ID = 'customers/LOAD_CUSTOMER_BY_ID',
  LOAD_CUSTOMER_BY_ID_SUCCESS = 'customers/LOAD_CUSTOMER_BY_ID_SUCCESS',
  LOAD_CUSTOMER_BY_ID_FAILURE = 'customers/LOAD_CUSTOMER_BY_ID_FAILURE',

  LOAD_CUSTOMER_PRODUCTS_DESCRIPTION = 'customers/LOAD_CUSTOMER_PRODUCTS_DESCRIPTION',
  LOAD_CUSTOMER_PRODUCTS_DESCRIPTION_V2 = 'customers/LOAD_CUSTOMER_PRODUCTS_DESCRIPTION_V2',
  LOAD_CUSTOMER_PRODUCTS_DESCRIPTION_SUCCESS = 'customers/LOAD_CUSTOMER_PRODUCTS_DESCRIPTION_SUCCESS',
  LOAD_CUSTOMER_PRODUCTS_DESCRIPTION_FAILURE = 'customers/LOAD_CUSTOMER_PRODUCTS_DESCRIPTION_FAILURE',

  LOAD_CUSTOMER_BLOCKS = 'customers/LOAD_CUSTOMER_BLOCKS',
  LOAD_CUSTOMER_BLOCKS_SUCCESS = 'customers/LOAD_CUSTOMER_BLOCKS_SUCCESS',
  LOAD_CUSTOMER_BLOCKS_FAILURE = 'customers/LOAD_CUSTOMER_BLOCKS_FAILURE',

  LOAD_CUSTOMER_PURCHASE_RECEIVERS = 'customers/LOAD_CUSTOMER_PURCHASE_RECEIVERS',
  LOAD_CUSTOMER_PURCHASE_RECEIVERS_SUCCESS = 'customers/LOAD_CUSTOMER_PURCHASE_RECEIVERS_SUCCESS',
  LOAD_CUSTOMER_PURCHASE_RECEIVERS_FAILURE = 'customers/LOAD_CUSTOMER_PURCHASE_RECEIVERS_FAILURE',

  SET_CREDIT_RENEW_CODE = 'customers/SET_CREDIT_RENEW_CODE',

  CLEAN_ERRORS = 'customers/CLEAN_ERRORS'
}

export enum ECreditRenewStatus {
  IN_PROCESS = 'in_process',
  CANCELED = 'canceled'
}

export interface ICustomer {
  customerId: string;
  name: string;
  parentCompany?: string;
  taxNumber?: string;
  locality: ILocality2;
  salesArea: ISaleArea[];
  productsDescriptionResponse?: IProductDescriptionResponse;
  blocks?: IBlock[];
  purchaseReceivers?: IPurchaseReceiver[];

  creditRenew?: boolean;
  creditRenewCode?: string;
  creditRenewRequestId?: string;
  creditRenewRequestStatus?: ECreditRenewStatus;

  lastUpdateTime?: number | undefined;

  isParentCompany?: boolean;

  hasNewContracts?: boolean;
  division: string[];
  customerType?: string;
  bpType?: string;
}

export type TMinimalDescribeICustomer = Pick<
  ICustomer,
  'customerId' | 'locality' | 'name' | 'taxNumber'
>;

export interface CustomersState {
  customers: ICustomer[];
  loading: boolean;
  error: boolean;
  errorMessage?: string;

  loadingCustomerById: boolean;
  errorBp?: boolean;

  loadingBlocks?: boolean;
  errorBlocks?: boolean;

  loadingProductDescription?: boolean;
  errorProductDescription?: boolean;

  loadingPurchaseReceivers?: boolean;
  errorPurchaseReceivers?: boolean;

  initialized?: boolean;
}

export interface IProductDescriptionResponse {
  products: IProductDescription[];
  customerProductsAvailable: {
    productsAvailable: boolean;
  };
}
export interface IProductDescription {
  customer: string;
  productCustomer: string;
  productDescription: string;
  productGerdau: number;
  salesDate: string;
}

export interface SkuJsonProps {
  codigo?: number;
  'descricao-interna': string;
  'descricao-mercadologica': string;
  productGerdau?: number;
}

export interface SkuJsonProps {
  codigo?: number;
  'descricao-interna': string;
  'descricao-mercadologica': string;
  productGerdau?: number;
}

export enum ECustomerBlockType {
  PARTIDAS_VENCIDAS = 'Partidas Vencidas',

  LIMITE_CREDITO_EXCEDIDO = 'Limite Crédito Excedido',

  LIMITE_CREDITO_EXPIRADO = 'Limite Crédito Expirado',

  CLIENTE_INATIVO = 'Cliente Inativo',
  PERIGO_OU_FRAUDE = 'Perigo ou Fraude',
  FALENCIA_CONCORDATA = 'Falência/Concordata',
  BLOQUEIO_AREA_COBRANCA = 'Bloqueio pela Área de Cobrança',
  BLOQUEIO_AREA_JURIDICA = 'Bloqueio pela Área Jurídica',
  PROTESTOS = 'Protestos',
  CHEQUE_DEVOLVIDO = 'Cheque Devolvido',
  NOVACAO_DIVIDA = 'Novação Dívida',
  LUCROS_PERDAS_PDD = 'Lucros e Perdas / PDD',
  PRELIMINAR = 'Preliminar',
  JOB_COMPLETO = 'Job Completo',
  RECUPERACAO_JUDICIAL = 'Recuperação Judicial',
  TRADEMASTER = 'Trademaster',
  ACORDO_VERBAL = 'Acordo Verbal',
  PAGAMENTO_CAMPANHA = 'Pagamento através de campanha',
  ORDER = 'order',
  SHIPPING = 'shipping',
  BILLING = 'billing',
  FINANCIAL = 'financial',
  REGISTER = 'register'
}
interface ICustomerBlockInfo {
  address: string;
  city: string;
  cnpj: string;
  code: string;
  country: string;
  name: string;
  neighborhood: string;
  state: string;
  zipcode: string;
  blocks?: IBlock[];
}
export interface ICustomerBlock extends ICustomerBlockInfo {
  subsidiaries: ICustomerBlockInfo[];
}

export interface IBlock {
  description: string;
  id: string;
  type: ECustomerBlockType;
}

export interface IPurchaseReceiver {
  customerId: string;
  name: string;
  address: string;
  city: string;
  state: string;
  taxNumber: string;
  postalCode: string;
}

export interface ISaleArea {
  saleOrg: string;
  saleTeam: string;
}
